import React from 'react';
import { CRITERIA_INFO } from '../constants';

export default function CBadge({ criteria, id, tip, toggleTip }) {
  const c = CRITERIA_INFO[criteria]; if (!c) return null;
  const isOpen = tip === id;
  return (
    <span style={{ position: "relative", display: "inline-flex" }}>
      <button onClick={e => { e.stopPropagation(); toggleTip(id) }} style={{ fontSize: 8, fontFamily: "JetBrains Mono", fontWeight: 700, color: c.color, background: c.color + "18", padding: "2px 6px", borderRadius: 3, border: `1px solid ${isOpen ? c.color + "55" : "transparent"}`, cursor: "pointer", letterSpacing: .3, display: "flex", alignItems: "center", gap: 3 }}>
        {c.label}<span style={{ fontSize: 7, opacity: .6 }}>ⓘ</span>
      </button>
      {isOpen && <div onClick={e => e.stopPropagation()} style={{ position: "absolute", top: "100%", left: 0, marginTop: 4, width: 260, background: "var(--bs-surface, #1a1a1a)", border: `1px solid ${c.color}33`, borderRadius: 8, padding: "10px 12px", zIndex: 50, boxShadow: "0 8px 24px #000a" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <span style={{ fontSize: 9, fontFamily: "JetBrains Mono", fontWeight: 700, color: c.color }}>{c.label}</span>
          <span style={{ fontSize: 8, fontFamily: "JetBrains Mono", color: "var(--bs-muted, #555)" }}>{c.weight}</span>
        </div>
        <p style={{ fontSize: 10, color: "var(--bs-body, #999)", lineHeight: 1.4, margin: "4px 0" }}>{c.what}</p>
        <p style={{ fontSize: 9, color: "var(--bs-muted, #666)", fontFamily: "JetBrains Mono", lineHeight: 1.3 }}>{c.standard}</p>
      </div>}
    </span>);
}
